export default class LocalStorageService {
    static keys = {
        // Auth token
        token: "bt",
        // Auth token expiration
        tokenExpiration: "te",
        // Application token of Biz TASK
        bizTaskServiceApplicationId: "btsai",
        // Application token of Biz NOTE
        bizNoteServiceApplicationId: "bnsai",
        /** Partner configuration catalog + values cache (TTL-managed by the provider). */
        partnerConfiguration: 'pcfg',
        // For firebase activation / deactivation, set by our firebase api
        notificationToken: 'fbmt',
        // so we determine if we should show the new versions dialog or not.
        readNewVersionsTimestamp: 'rnvts',
        // so we determine if we should show the birthday dialog or not.
        seenHappyBirthdayDialog: 'shbd',
        // so we determine if we should show the welcome to panel dialog or not.
        seenWelcomeToPanelDialogTimestamp: 'swtpdt',
        // we use local-storage for persistence. used by data-grid-provider to save its state.
        dataGridsSavedState: "dgss",
        // for biz-print dialog.
        printApplicationToken: "pat",
        // Used by useIndustry
        searchSchema: "sschm",
        industryPropertyGroups: "ipg",
        industryPropertyGroupAttributes: "ipga",
        // Used by usePriceLevelDictionary
        priceLevelDictionary: "pld",
        // For nexus search config.
        nexusSearchConfigs: "nsc",
        // App-bar Nexus vs System search mode (fast local mirror of UI component save).
        appBarSearchMode: "absm",
        // For Login / Logout URLS for auth purposes.
        authNavigation: 'an',
        // needed to immediately set the partnerId used by the AccessLevelsProvider
        operatorId: 'coi',
        // The profile base url of the operators. Set by login API.
        operatorImageProfileBaseUrl: 'oipbu',
        // needed to immediately set the partnerId used by the AccessLevelsProvider
        operatorPartnerId: "opi",
        // need to save and then use on refreshed pages until we fetch the API (truthy placeholder)
        partnerColorTheme: "pct",
        // whether the login is locked.
        loginLocked: 'll',
        // Monotonic id of the current login. Bumped only when a new token is stored.
        authGeneration: 'ag',
        // the app version, used to determine if we should show the new version dialog or not.
        appVersion: 'av',
    }

    static eventKeys = {
        whatsNewDialog: 'whats-new-dialog',
        welcomeToPanelDialog: 'welcome-to-panel-dialog',
        logout: 'logout',
    }

    /**
     * Saves data into local storage
     */
    static set = (name: string, value: string) => {
        return localStorage.setItem(name, value);
    };

    /**
     * Extracts the data from local storage
     */
    static get = (name: string | string[]): any | Array<any> => {
        if (typeof name === "string") {
            return localStorage[name];
        }
        if (Array.isArray(name)) {
            return name.map(e => localStorage[e]);
        }
    };

    /**
     * Returns an array of all the keys in the local storage that are defined in the LocalStorageService.keys object.
     */
    static getAllKeys = (logout = false) => {
        const keys = Object.values(LocalStorageService.keys);
        const persistentKeys = [
            LocalStorageService.keys.readNewVersionsTimestamp,
            LocalStorageService.keys.seenHappyBirthdayDialog,
            LocalStorageService.keys.seenWelcomeToPanelDialogTimestamp,
            LocalStorageService.keys.appVersion,
        ]
        if (logout) {
            return keys.filter(key => !persistentKeys.includes(key));
        }
        return keys;
    }

    /**
     * Removes the key/value pair with the given key from the list associated with the object,
     * if a key/value pair with the given key exists.
     */
    static remove = (name: string) => {
        return localStorage.removeItem(name);
    }

    /**
     * Returns the current value associated with the given key, or null if the given key does not exist in the list
     * associated with the object.
     */
    static removeAll = () => {
        return localStorage.clear();
    }

    /**
     * Returns all the available data from the local storage
     */
    static getAll = () => {
        const keys = LocalStorageService.keys;
        const get = LocalStorageService.get;
        let result: any = {};
        for (let key in keys) {
            result[key] = get(key);
        }
        return result;
    }
}


